import React, { useState, useEffect, useContext } from "react";
import { StoreContext } from "components/StoreContext";
import DynamicTextPage from "components/DynamicTextPage";

const CookiePolicy = () => {
  const [loading, updateLoading] = useState(true);
  const [cookiePolicy, setCookiePolicy] = useState(null);
  const { store, StoreAPI, config } = useContext(StoreContext);
  const { cookieBotUrl } = config;

  useEffect(() => {
    if (store.loaded) {
      updateLoading(true);
      StoreAPI.get(`Marketing/cookiepolicy`)
        .then(response => {
          setCookiePolicy(response.data.cookiePolicy);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          updateLoading(false);
        });
    }
  }, [store.loaded, StoreAPI]);

  return (
    <>
      <DynamicTextPage
        loading={loading}
        title="Cookie Policy"
        state={cookiePolicy}
        policy={cookieBotUrl}
      />
    </>
  );
};

export default CookiePolicy;
